import { SortMethod } from "@iventis/components";

export const rootNodeId = "root-node";

export const sortingMethods: SortMethod[] = [{ id: "default", displayName: "Projects (A-Z)" }];
